export const quickarealist = [{
  title: '销售',
  id: 'xiaoshou',
  areachild: [{
    subtitle: '合同回款划拨',
    icon: 'icon-xiaoshou-hetonghuikuanhuabo',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 76,
    url: 'contractReturnMoneyTransfer'
  }, {
    subtitle: '销售合同开票记录',
    icon: 'icon-xiaoshou-xiaoshouhetongkaipiaojilu',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 80,
    url: 'contractInvoicingManagement'
  }, {
    subtitle: '售后记录',
    icon: 'icon-xiaoshou-shouhoujilu',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 81,
    url: 'afterSaleRecord'
  }, {
    subtitle: '询价管理',
    icon: 'icon-xiaoshou-xunjiaguanli',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 75,
    url: 'inquiryList'
  }, {
    subtitle: '销售合同管理',
    icon: 'icon-xiaoshou-xiaoshouhetongguanli',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 177,
    url: 'contractList'
  }, {
    subtitle: '销售备货记录',
    icon: 'icon-xiaoshou-xiaoshoubeihuojilu',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 77,
    url: 'sellStockRecord'
  }, {
    subtitle: '销售发货记录',
    icon: 'icon-xiaoshou-xiaoshoufahuojilu',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 78,
    url: 'sellShipmentsRecord'
  }, {
    subtitle: '客户提现记录',
    icon: 'icon-xiaoshou-kehutixianjilu',
    patherid: 'xiaoshou',
    bgcolor: '#5AA5FF',
    id: 178,
    url: 'customerWithdrawalRecord'
  }]
}, {
  title: '采购',
  id: 'caigou',
  areachild: [{
    subtitle: '询价反馈管理',
    icon: 'icon-caigou-xunjiafankuiguanli',
    patherid: 'caigou',
    bgcolor: '#FF7E99',
    id: 115,
    url: 'waitFeedbackEnquiryList'
  }, {
    subtitle: '采购配货管理',
    icon: 'icon-caigou-caigoupeihuoguanli',
    patherid: 'caigou',
    bgcolor: '#FF7E99',
    id: 116,
    url: 'waitAllocateCargoList'
  }, {
    subtitle: '采购计划',
    icon: 'icon-caigou-caigoujihua',
    patherid: 'caigou',
    bgcolor: '#FF7E99',
    id: 117,
    url: 'purchasePlanList'
  }, {
    subtitle: '采购合同管理',
    icon: 'icon-caigou-caigouhetongguanli',
    patherid: 'caigou',
    bgcolor: '#FF7E99',
    id: 118,
    url: 'purchaseContractList'
  }, {
    subtitle: '采购发货管理',
    icon: 'icon-caigou-caigoufahuoguanli',
    patherid: 'caigou',
    bgcolor: '#FF7E99',
    id: 119,
    url: 'purchaseShipmentsRecord'
  }, {
    subtitle: '采购支付管理',
    icon: 'icon-caigou-caigouzhifuguanli',
    patherid: 'caigou',
    bgcolor: '#FF7E99',
    id: 120,
    url: 'waitGatheringSupplierList'
  }
  // , {
  //   subtitle: '售后维修',
  //   icon: 'icon-caigou-shouhouweixiu',
  //   patherid: 'caigou',
  //   bgcolor: '#FF7E99',
  //   url: ''
  // }, {
  //   subtitle: '退货拆分管理',
  //   icon: 'icon-caigou-tuihuochaifenguanli',
  //   patherid: 'caigou',
  //   bgcolor: '#FF7E99',
  //   url: ''
  // }, {
  //   subtitle: '退货方案管理',
  //   icon: 'icon-caigou-tuihuofanganguanli',
  //   patherid: 'caigou',
  //   bgcolor: '#FF7E99',
  //   url: ''
  // }, {
  //   subtitle: '退货任务管理',
  //   icon: 'icon-caigou-tuihuorenwuguanli',
  //   patherid: 'caigou',
  //   bgcolor: '#FF7E99',
  //   url: ''
  // }
  ]
}, {
  title: '财务',
  id: 'caiwu',
  areachild: [{
    subtitle: '承兑汇票收款记录',
    icon: 'icon-xiaoshou-chengduihuipiaoshoukuanjilu',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 79,
    url: 'acceptDraftCollections'
  }, {
    subtitle: '待审核付款申请',
    icon: 'icon-caiwu-daishenhefukuanshenqing',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 155,
    url: 'waitAuditPayApplyList'
  }, {
    subtitle: '待处理付款申请',
    icon: 'icon-caiwu-daichulifukuanshenqing',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 156,
    url: 'waitDisposePayApplyList'
  }, {
    subtitle: '银行对账单收款管理',
    icon: 'icon-caiwu-yinhangduizhangdanshoukuanguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 157,
    url: 'bankCollectionList'
  }, {
    subtitle: '其他收款管理',
    icon: 'icon-caiwu-qitashoukuanguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 158,
    url: 'otherCollectionList'
  }, {
    subtitle: '开票管理',
    icon: 'icon-caiwu-kaipiaoguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 161,
    url: 'financeInvoiceManage'
  }, {
    subtitle: '收票管理',
    icon: 'icon-caiwu-shoupiaoguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 162,
    url: 'financeChecksManage'
  }, {
    subtitle: '普通发票退票管理',
    icon: 'icon-caiwu-putongfapiaotuipiaoguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 163,
    url: 'commonReturnTicketApplyList'
  }, {
    subtitle: '红字发票退票管理',
    icon: 'icon-caiwu-hongzifapiaotuipiaoguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 164,
    url: 'redReturnTicketApplyList'
  }, {
    subtitle: '余额管理',
    icon: 'icon-caiwu-yueguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 166,
    url: 'balanceManage'
  }, {
    subtitle: '承兑汇票收票管理',
    icon: 'icon-caiwu-chengduihuipiaoshoupiaoguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 79,
    url: 'acceptDraftCollectionsManage'
  }, {
    subtitle: '承兑汇票管理',
    icon: 'icon-caiwu-chengduihuipiaoguanli',
    patherid: 'caiwu',
    bgcolor: '#5AA5FF',
    id: 159,
    url: 'acceptDraftManage'
  }]
}, {
  title: '仓储',
  id: 'cangchu',
  areachild: [{
    subtitle: '备货管理',
    icon: 'icon-cangchu-beihuoguanli',
    patherid: 'cangchu',
    bgcolor: '#FFAF0D',
    id: 149,
    url: 'inventoryStockList'
  }, {
    subtitle: '物流发货管理',
    icon: 'icon-cangchu-wuliufahuoguanli',
    patherid: 'cangchu',
    bgcolor: '#FFAF0D',
    id: 150,
    url: 'logisticsShipmentsList'
  }, {
    subtitle: '自提发货管理',
    icon: 'icon-cangchu-zitifahuoguanli',
    patherid: 'cangchu',
    bgcolor: '#FFAF0D',
    id: 151,
    url: 'oneselfExtractShipmentsList'
  }, {
    subtitle: '仓库发货管理',
    icon: 'icon-cangchu-cangkufahuoguanli',
    patherid: 'cangchu',
    bgcolor: '#FFAF0D',
    id: 152,
    url: 'warehouseShipmentsList'
  }, {
    subtitle: '物流入库管理',
    icon: 'icon-cangchu-wuliurukuguanli',
    patherid: 'cangchu',
    bgcolor: '#FFAF0D',
    id: 153,
    url: 'logisticsGoToWarehouseList'
  }, {
    subtitle: '配送入库管理',
    icon: 'icon-cangchu-peisongrukuguanli',
    patherid: 'cangchu',
    bgcolor: '#FFAF0D',
    id: 154,
    url: 'distributionGoToWarehouseList'
  }]
}, {
  title: '产品',
  id: 'changping',
  areachild: [{
    subtitle: '产品管理',
    icon: 'icon-chanpin-chanpinguanli',
    patherid: 'changping',
    bgcolor: '#FF7273',
    id: 52,
    url: 'productList'
  }, {
    subtitle: '品牌管理',
    icon: 'icon-chanpin-pinpaiguanli',
    patherid: 'changping',
    bgcolor: '#FF7273',
    id: 51,
    url: 'productBrandSeries'
  }, {
    subtitle: '系数调整',
    icon: 'icon-chanpin-xitongtiaozheng',
    patherid: 'changping',
    bgcolor: '#FF7273',
    id: 86,
    url: 'coefficientAdjustment'
  }]
}, {
  title: 'CRM',
  id: 'crm',
  areachild: [{
    subtitle: '客户管理',
    icon: 'icon-CRM-kehuguanli',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 13,
    url: 'myCustomer'
  }, {
    subtitle: '客户关系管理',
    icon: 'icon-CRM-kehuguanxiguanli1',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 29,
    url: 'transfer'
  }, {
    subtitle: '团队客户库',
    icon: 'icon-CRM-tuanduikehuku',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 63,
    url: 'teamCustomer'
  }, {
    subtitle: '客户设置',
    icon: 'icon-CRM-kehushezhi',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 30,
    url: 'managementSet'
  }, {
    subtitle: '特价审批管理',
    icon: 'icon-CRM-tejiashenpiguanli',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 60,
    url: 'special'
  }, {
    subtitle: '供应商管理',
    icon: 'icon-CRM-gongyingshangguanli',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 46,
    url: 'supplierList'
  }, {
    subtitle: '报价管理',
    icon: 'icon-CRM-baojiaguanli',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 71,
    url: 'quoteCollect'
  }, {
    subtitle: '活动管理',
    icon: 'icon-CRM-huodongguanli',
    patherid: 'crm',
    bgcolor: '#7FCF56',
    id: 73,
    url: 'activityList'
  }]
}]
